import { adminApi } from '@/config/axios.config';
import { Role, RoleOption, RoleFilters } from '../types/role-types';

export const rolesApiService = {
  // Obtener todos los roles con filtros
  async getRoles(filters: RoleFilters = {}): Promise<Role[]> {
    const params = new URLSearchParams();

    if (filters.category) params.append('category', filters.category);
    if (filters.isAdmin !== undefined)
      params.append('isAdmin', filters.isAdmin.toString());
    if (filters.isActive !== undefined)
      params.append('isActive', filters.isActive.toString());
    if (filters.businessAdminOnly) params.append('businessAdminOnly', 'true');

    const response = await adminApi.get(`/roles?${params.toString()}`);
    return response.data?.data || response.data;
  },

  // Obtener roles de negocio admin (para dropdown de creación de clientes)
  async getBusinessAdminRoles(): Promise<RoleOption[]> {
    const response = await adminApi.get('/roles/business-admin');
    return response.data?.data || response.data;
  },

  // Obtener opciones de roles con filtros
  async getRoleOptions(filters: RoleFilters = {}): Promise<RoleOption[]> {
    const params = new URLSearchParams();

    if (filters.category) params.append('category', filters.category);
    if (filters.isAdmin !== undefined)
      params.append('isAdmin', filters.isAdmin.toString());
    if (filters.isActive !== undefined)
      params.append('isActive', filters.isActive.toString());
    if (filters.businessAdminOnly) params.append('businessAdminOnly', 'true');

    const response = await adminApi.get(`/roles/options?${params.toString()}`);
    return response.data?.data || response.data;
  },

  // Obtener un rol por ID
  async getRoleById(id: string): Promise<Role> {
    const response = await adminApi.get(`/roles/${id}`);
    return response.data?.data || response.data;
  },

  // Obtener un rol por código
  async getRoleByCode(code: string): Promise<Role> {
    const response = await adminApi.get(`/roles/code/${code}`);
    return response.data?.data || response.data;
  },
};

export default rolesApiService;
